import { AnnualSecurityReportFilter } from "../types";
import { User } from "../../../../auth/types";
import { httpWebApi } from "../../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../../core/util/functions";

export const getAnnualSecurityExcel = (
  user: User,
  filter: AnnualSecurityReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getsecannualtradingxls",
    params: {
      userid: user.userId,
      year: filter.year,
    },
  });
};

export default getAnnualSecurityExcel;
